function toSafeDate(year, month, day = 1) {
  const date = new Date(Number(year), Number(month) - 1, Number(day));
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatAnalyticsPeriodLabel(period) {
  const value = String(period ?? '');
  if (!value) return value;

  const quarterMatch = value.match(/^(\d{4})-Q([1-4])$/i);
  if (quarterMatch) {
    return `Q${quarterMatch[2]} ${quarterMatch[1]}`;
  }

  const dayMatch = value.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
  if (dayMatch) {
    const [, year, month, day] = dayMatch;
    const date = toSafeDate(year, month, day);
    if (date) {
      return date.toLocaleDateString(undefined, {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      });
    }
  }

  const monthMatch = value.match(/^(\d{4})-(\d{1,2})$/);
  if (monthMatch) {
    const [, year, month] = monthMatch;
    const date = toSafeDate(year, month);
    if (date) {
      return date.toLocaleDateString(undefined, {
        month: 'short',
        year: 'numeric'
      });
    }
  }

  return value;
}
